import { useEffect } from 'react'
import cx from 'classnames'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { scrollTo } from 'libraries/front-end-core/helpers/document'
import { Document } from 'services/DocumentService'
import Icon from 'components/shared/Icon'
import DocumentsList from 'components/documents/DocumentsList'

interface SectionProps {
  aol: string
  sectionId: string
  title: string
  focusedId: string | null
  documents: Document[]
  selectedDocuments: Document[]
  pageId: string
  rootId?: string
  favourites?: Set<string>
}

export default function Section ({
  aol,
  focusedId,
  sectionId,
  title,
  documents,
  selectedDocuments,
  pageId,
  rootId,
  favourites
}: SectionProps): JSX.Element {
  const elementId = `${sectionId}-${documents.length}`
  const defaultOpen = focusedId === sectionId || documents.some(document => document.id === focusedId)
  useEffect(() => {
    if (focusedId === sectionId) {
      scrollTo({ pageId, id: elementId, animate: true })
    }
  }, [focusedId, sectionId, pageId])

  return (
    <Disclosure
      id={elementId}
      defaultOpen={defaultOpen}
      as='div'
      className='bb b--precedents-blue'
    >
      {({ open }: { open: boolean }) => (
        <>
          <DisclosureButton
            as='h2'
            className={cx('ph6 pv5 w-100 flex justify-between items-center ma0 f5 pointer', {
              'bg-precedents-blue white': open,
              'bg-precedents-blue-10 black': !open
            })}
          >
            {title}
            <div className='flex items-center justify-center'>
              {documents.length}
              <Icon
                name={open ? 'icon-chevron-up' : 'icon-chevron-down'}
                className={cx('w7 ml5', { black: !open, white: open })}
              />
            </div>
          </DisclosureButton>
          <div className='bg-white'>
            <DisclosurePanel>
              <DocumentsList
                rootId={rootId}
                aol={aol}
                documents={documents}
                selectedDocuments={selectedDocuments}
                focusedId={focusedId}
                pageId={pageId}
                expanded={open}
                favourites={favourites}
              />
            </DisclosurePanel>
          </div>
        </>
      )}
    </Disclosure>
  )
}
